import React from "react";
import { Box, Grid, Skeleton } from "@mui/material";

type HitsRowsSkeletonProps = {
  items?: number;
};

const HitsRowsSkeleton: React.FunctionComponent<any> = (props): JSX.Element => {
  const { items = 5 }: HitsRowsSkeletonProps = props;
  return (
    <Grid container spacing={2} marginTop="1rem">
      {[...Array(items)].map((e, i) => {
        return (
          <Grid item xs={12} height="auto">
            <Box mx="20px">
              <Skeleton variant="rectangular" width="100%" height="184px" />
            </Box>
          </Grid>
        );
      })}
      <Grid item xs={12} textAlign="center">
        <Box textAlign="center" display="inline-block">
          <Skeleton variant="rectangular" width="117px" height="40px" />
        </Box>
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Box textAlign="center" display="inline-block">
          <Skeleton variant="rectangular" width="123px" height="19px" />
        </Box>
      </Grid>
    </Grid>
  );
};

export default React.memo(HitsRowsSkeleton);
